"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pipe_1 = require("./pipe");
var rx = require("rxjs");
var _uuidRandom = require("uuid-random");
var interop_1 = require("./interop");
var uuidRandom = interop_1.interopRequireDefault(_uuidRandom);
/**Devuelve un nuevo UUID */
function uuid() {
    return uuidRandom();
}
exports.uuid = uuid;
/**Devuelve true si todos los elementos de un arreglo encajan con el predicado */
function all(arr, pred) {
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var x = arr_1_1.value;
            if (!pred(x))
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
    var e_1, _a;
}
exports.all = all;
/**Devuelve true si todos los elementos de un arreglo son iguales. Si el arreglo esta vacío devuelve true
 * @param comparer El comparador de igualdar, por default es @see referenceEquals
 */
function allEqual(arr, comparer) {
    if (arr.length == 0)
        return true;
    var effectiveComparer = comparer || referenceEquals;
    var first = arr[0];
    for (var i = 1; i < arr.length; i++) {
        var it_1 = arr[i];
        if (!effectiveComparer(first, it_1))
            return false;
    }
    return true;
}
exports.allEqual = allEqual;
/**Devuelve true si por lo menos un elemento del arreglo encaja con el predicado, o si existe por lo menos un elemento en caso
 * de que el predicado este indefinido
 */
function any(arr, pred) {
    if (pred) {
        try {
            for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                var x = arr_2_1.value;
                if (pred(x))
                    return true;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (arr_2_1 && !arr_2_1.done && (_a = arr_2.return)) _a.call(arr_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    }
    else {
        return arr.length > 0;
    }
    var e_2, _a;
}
exports.any = any;
/**Devuelve true si el valor existe en el arreglo */
function contains(arr, value, comparer) {
    var effectiveComparer = comparer || referenceEquals;
    return any(arr, function (x) { return effectiveComparer(x, value); });
}
exports.contains = contains;
/**Devuelve true si todos los valores en @see values existen en el arreglo @see arr . Si @see values esta vacío devuelve true */
function containsAll(arr, values, comparer) {
    return all(values, function (x) { return contains(arr, x, comparer); });
}
exports.containsAll = containsAll;
/**Devuelve true si existe algun valor en @see values que exista en @see arr . Si @see values esta vacío devuelve false */
function containsAny(arr, values, comparer) {
    return any(values, function (x) { return contains(arr, x, comparer); });
}
exports.containsAny = containsAny;
/**
 * Alias para el operador ===
 * @param a
 * @param b
 */
function referenceEquals(a, b) {
    return a === b;
}
exports.referenceEquals = referenceEquals;
/**Compara dos arreglos valor por valor */
function sequenceEquals(a, b, comparer) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (a.length != b.length)
        return false;
    comparer = comparer || (function (a, b) { return a === b; });
    for (var i = 0; i < a.length; i++) {
        if (!comparer(a[i], b[i]))
            return false;
    }
    return true;
}
exports.sequenceEquals = sequenceEquals;
/**Devuelve true si 2 arreglos contienen los mismos valores, sin considerar el orden o la cantidad de veces que el mismo valor esta repetido en el arreglo
 * @param comparer Función que se usa para comparar los elementos, si no se especifica, se usa el referenceEquals
 */
function setEquals(a, b, comparer) {
    try {
        for (var a_1 = __values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()) {
            var aItem = a_1_1.value;
            if (!contains(b, aItem, comparer))
                return false;
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    try {
        for (var b_1 = __values(b), b_1_1 = b_1.next(); !b_1_1.done; b_1_1 = b_1.next()) {
            var bItem = b_1_1.value;
            if (!contains(a, bItem, comparer))
                return false;
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (b_1_1 && !b_1_1.done && (_b = b_1.return)) _b.call(b_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return true;
    var e_3, _a, e_4, _b;
}
exports.setEquals = setEquals;
function shallowEqualsCompareByRef(x) {
    var type = typeof x;
    var primTypeByRef = type == "string" || type == "boolean" || type == "number" || type == "symbol" || type == "function";
    return primTypeByRef || isPromiseLike(x) || isObservable(x);
}
/**Compara dos objetos propiedad por propiedad */
function shallowEquals(a, b, comparer) {
    if (typeof (a) == "function" || typeof (b) == "function") {
        //Las funciones se comparan por igualdad estricta:
        return a === b;
    }
    if ((typeof a) != (typeof b))
        return false;
    if (shallowEqualsCompareByRef(a) || shallowEqualsCompareByRef(b)) {
        return a === b;
    }
    if (a instanceof Date || b instanceof Date) {
        if (a instanceof Date && b instanceof Date) {
            return a.valueOf() == b.valueOf();
        }
        else
            return false;
    }
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (canBeArray(a) && canBeArray(b)) {
        return sequenceEquals(toArray(a), toArray(b), comparer);
    }
    var aKeys = Object.keys(a).map(function (x) { return x; });
    var bKeys = Object.keys(b).map(function (x) { return x; });
    if (aKeys.length != bKeys.length)
        return false;
    return sequenceEquals(aKeys.map(function (x) { return a[x]; }), aKeys.map(function (x) { return b[x]; }), comparer);
}
exports.shallowEquals = shallowEquals;
/**
 * Compara 2 objetos propiedad por propiedad, devuelve un objeto con las propiedades que son diferentes asignadas a true
 * @param a Objeto a
 * @param b Objecto b
 * @param comparer Comparador de las propiedades. Se usa por default referenceEquals
 */
function shallowDiff(a, b, comparer) {
    var eComp = comparer || referenceEquals;
    var props = pipe_1.pipe(union(Object.keys(a), Object.keys(b)), function (curr) { return curr.map(function (x) { return ({ key: x, value: a[x], otherValue: b[x], refEquals: a[x] === b[x] }); }); }, function (curr) { return curr.filter(function (x) { return !eComp(x.value, x.otherValue); }); }, function (curr) { return curr.map(function (x) { return x.key; }); }, function (curr) { return arrayToMap(curr, function (item) { return item; }, function (item) { return true; }); });
    return props;
}
exports.shallowDiff = shallowDiff;
/**Convierte un ArrayLike o Iterable en un arreglo. Si el valor ya es un arreglo devuelve el valor */
function toArray(arr) {
    if (arr instanceof Array) {
        return arr;
    }
    var isArrayLike = function (x) { return x.lenght !== undefined; };
    var ret = [];
    if (isArrayLike(arr)) {
        for (var i = 0; i < arr.length; i++) {
            ret.push(arr[i]);
        }
    }
    else {
        try {
            for (var arr_3 = __values(arr), arr_3_1 = arr_3.next(); !arr_3_1.done; arr_3_1 = arr_3.next()) {
                var a = arr_3_1.value;
                ret.push(a);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (arr_3_1 && !arr_3_1.done && (_a = arr_3.return)) _a.call(arr_3);
            }
            finally { if (e_5) throw e_5.error; }
        }
    }
    return ret;
    var e_5, _a;
}
exports.toArray = toArray;
/**Devuelve true si un objeeto se puede convertir a un arreglo utilizando la función toArray */
function canBeArray(arr) {
    return isArrayLike(arr) || hasIterationProtocol(arr);
}
exports.canBeArray = canBeArray;
/**Devuelve true si x es un array o un array like */
function isArrayLike(x) {
    return x != null && x.length !== undefined;
}
exports.isArrayLike = isArrayLike;
var hasIterationProtocol = function (variable) { return variable !== null && Symbol.iterator in Object(variable); };
function deepEquals(a, b) {
    var deep = function (a, b) { return shallowEquals(a, b, deep); };
    return deep(a, b);
}
exports.deepEquals = deepEquals;
/**Convierte un arreglo a un objeto */
function toMap(arr, key, value) {
    var ret = {};
    try {
        for (var arr_4 = __values(arr), arr_4_1 = arr_4.next(); !arr_4_1.done; arr_4_1 = arr_4.next()) {
            var x = arr_4_1.value;
            ret[key(x)] = value(x);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (arr_4_1 && !arr_4_1.done && (_a = arr_4.return)) _a.call(arr_4);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return ret;
    var e_6, _a;
}
exports.toMap = toMap;
/**Aplana una colección de colecciones */
function flatten(arr) {
    var ret = [];
    try {
        for (var arr_5 = __values(arr), arr_5_1 = arr_5.next(); !arr_5_1.done; arr_5_1 = arr_5.next()) {
            var a = arr_5_1.value;
            ret.push.apply(ret, __spread(a));
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (arr_5_1 && !arr_5_1.done && (_a = arr_5.return)) _a.call(arr_5);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return ret;
    var e_7, _a;
}
exports.flatten = flatten;
/**Devuelve el primer elemento de un arreglo o indefinido si no se encontro ninguno, opcionalmente
 * filtrado por un predicado
 */
function first(arr, pred) {
    try {
        for (var arr_6 = __values(arr), arr_6_1 = arr_6.next(); !arr_6_1.done; arr_6_1 = arr_6.next()) {
            var a = arr_6_1.value;
            if (!pred || pred(a))
                return a;
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (arr_6_1 && !arr_6_1.done && (_a = arr_6.return)) _a.call(arr_6);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return undefined;
    var e_8, _a;
}
exports.first = first;
/**
 * Devuelve el unico elemento de un arreglo que cumpla con la condición, si no se encontró ninguo o mas de uno devuelve undefined
 */
function single(arr, pred) {
    var firstItem = undefined;
    var first = false;
    try {
        for (var arr_7 = __values(arr), arr_7_1 = arr_7.next(); !arr_7_1.done; arr_7_1 = arr_7.next()) {
            var a = arr_7_1.value;
            var pass = !pred || pred(a);
            if (pass) {
                if (first) {
                    //mas de uno
                    return undefined;
                }
                else {
                    firstItem = a;
                    first = true;
                }
            }
        }
    }
    catch (e_9_1) { e_9 = { error: e_9_1 }; }
    finally {
        try {
            if (arr_7_1 && !arr_7_1.done && (_a = arr_7.return)) _a.call(arr_7);
        }
        finally { if (e_9) throw e_9.error; }
    }
    return firstItem;
    var e_9, _a;
}
exports.single = single;
/**Devuelve el ultimo elemento de un arreglo */
function last(arr) {
    return arr[arr.length - 1];
}
exports.last = last;
/**Agrupa un arreglo por una llave. Se preserva el orden original de los elementos del arreglo, segun los elementos agrupadores que aparezcan primero, tambien
 * el orden adentro del grupo es preservado
 * @param comparer Comparador de la llave por default es un shallowEquals
 */
function groupBy(arr, groupBy, comparer) {
    var ret = [];
    var comparerDefault = comparer || shallowEquals;
    var _loop_1 = function (x) {
        var key = groupBy(x);
        var firstItem = first(ret, function (x) { return comparerDefault(x.key, key); });
        if (firstItem === undefined) {
            ret.push({ key: key, items: [x] });
        }
        else {
            firstItem.items.push(x);
        }
    };
    try {
        for (var arr_8 = __values(arr), arr_8_1 = arr_8.next(); !arr_8_1.done; arr_8_1 = arr_8.next()) {
            var x = arr_8_1.value;
            _loop_1(x);
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (arr_8_1 && !arr_8_1.done && (_a = arr_8.return)) _a.call(arr_8);
        }
        finally { if (e_10) throw e_10.error; }
    }
    return ret;
    var e_10, _a;
}
exports.groupBy = groupBy;
function enumObject(obj, selector) {
    var defaultSelector = (function (key, value) { return ({ key: key, value: value }); });
    var effectiveSelector = selector || defaultSelector;
    if (selector) {
        return Object.keys(obj).map(function (key) { return selector(key, obj[key]); });
    }
    else {
        return Object.keys(obj).map(function (key) { return key; }).map(function (key) { return defaultSelector(key, obj[key]); });
    }
}
exports.enumObject = enumObject;
function arrayToMap(array, keySelector, valueSelector) {
    var defaultKeySelector = function (item) { return item.key; };
    var defaultValueSelector = function (item) { return item.value; };
    var effectiveKeySelector = keySelector || defaultKeySelector;
    var effectiveValueSelector = valueSelector || defaultValueSelector;
    var ret = {};
    try {
        for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
            var a = array_1_1.value;
            var key = effectiveKeySelector(a);
            var value = effectiveValueSelector(a);
            ret[key] = value;
        }
    }
    catch (e_11_1) { e_11 = { error: e_11_1 }; }
    finally {
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        }
        finally { if (e_11) throw e_11.error; }
    }
    return ret;
    var e_11, _a;
}
exports.arrayToMap = arrayToMap;
/**Obtiene los valores numericos de un enum */
function enumKeys(e) {
    return Object.keys(e).map(function (x) { return e[x]; }).filter(function (x) { return typeof (x) == "number"; });
}
exports.enumKeys = enumKeys;
/**
 * Filtra las propiedades de un objeto
 * @param obj Objeto que se va a filtrar
 * @param pred Predicado que va a determinar que propiedades si se van a conservar
 */
function filterObject(obj, pred) {
    var ret = {};
    for (var key in obj) {
        var value = obj[key];
        if (pred(value, key)) {
            ret[key] = value;
        }
    }
    return ret;
}
exports.filterObject = filterObject;
/**
 * Quita un conjunto de propiedades de un objeto
 * @param obj El objeto original
 * @param keys Las propiedades que se desean quitar
 */
function omit(obj, keys) {
    return filterObject(obj, function (value, key) { return !contains(keys, key); });
}
exports.omit = omit;
/**Quita las propiedades que esten indefinidas en un objeto */
function omitUndefined(obj) {
    return filterObject(obj, function (value) { return value !== undefined; });
}
exports.omitUndefined = omitUndefined;
/**Devuelve un objeto son solo ciertas propiedades del objeto incluidas. Si se escoge una propiedad que no existe en el objeto esta no estará incluida en el objeto devuelto */
function pick(obj) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    var ret = {};
    try {
        for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
            var key = props_1_1.value;
            if (key in obj) {
                ret[key] = obj[key];
            }
        }
    }
    catch (e_12_1) { e_12 = { error: e_12_1 }; }
    finally {
        try {
            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
        }
        finally { if (e_12) throw e_12.error; }
    }
    return ret;
    var e_12, _a;
}
exports.pick = pick;
/**Intercambia 2 elementos de un arreglo, si los indices dados estan afuera del arreglo, lanza una excepción */
function swapItems(array, a, b) {
    var inside = function (x) { return x >= 0 && x < array.length; };
    if (!inside(a) || !inside(b))
        throw new Error("Indice fuera de rango");
    return array.map(function (x, i, arr) {
        return i == a ? arr[b] :
            i == b ? arr[a] :
                arr[i];
    });
}
exports.swapItems = swapItems;
/**Mueve un elemento del arreglo de un indice a otro, note que no es igual a swapItems ya que al mover un elemento se conserva el orden de todos los de más elemento, esto no ocurre con el swap que
 * simplemente intercambia de posición 2 elementos. Si los indices estan fuera de rango lanza uan excepción
*/
function moveItem(array, sourceIndex, destIndex) {
    var inside = function (x) { return x >= 0 && x < array.length; };
    if (!inside(sourceIndex) || !inside(destIndex))
        throw new Error("Indice fuera de rango");
    //Si los valroes son iguales devuelve el arreglo tal cual
    if (sourceIndex == destIndex)
        return array;
    //Dirección del movimiento, puede ser -1 o +1
    var dir = Math.sign(destIndex - sourceIndex);
    var min = Math.min(sourceIndex, destIndex);
    var max = Math.max(sourceIndex, destIndex);
    return array.map(function (x, i, arr) {
        return (i < min || i > max) ? x :
            (i == destIndex) ? arr[sourceIndex] :
                arr[i + dir];
    });
}
exports.moveItem = moveItem;
/**Mueve un elemento hacia array o hacia abajo, si el elemento no se puede mover ya que esta en el borde del arreglo devuelve el arreglo tal cual */
function upDownItem(array, index, direction) {
    if ((index == 0 && direction == "up") || (index == array.length - 1 && direction == "down")) {
        return array;
    }
    else {
        return moveItem(array, index, index + (direction == "up" ? -1 : +1));
    }
}
exports.upDownItem = upDownItem;
function promiseAllObj(obj) {
    var keys = Object.keys(obj);
    var values = keys.map(function (key) { return obj[key]; });
    var all = Promise.all(values);
    var ret = all.then(function (arr) { return arr.map(function (value, index) { return ({ key: keys[index], value: value }); }); }).then(function (x) { return arrayToMap(x); });
    return ret;
}
exports.promiseAllObj = promiseAllObj;
/**Convierte un objeto de observables a un observable de objetos, el primer elemento del observable resultante se da cuando todos los observables del objeto lanzan el primer valor */
function objRxToRxObj(obj) {
    var keys = Object.keys(obj);
    ;
    var values = keys.map(function (key) { return obj[key].map(function (x) { return ({
        value: x,
        key: key
    }); }); });
    var combine = rx.Observable.combineLatest(values).map(function (x) { return arrayToMap(x); });
    return combine;
}
exports.objRxToRxObj = objRxToRxObj;
/**Convierte una promesa de un objeto a un objeto de promesas
 * @param include Nombres de las propiedades que se desean incluir en el objeto resultante
 */
function awaitObj(obj, include) {
    var ret = pipe_1.pipe(include, function (inc) { return filterObject(inc, function (x) { return !!x; }); }, function (inc) { return mapObject(inc, function (value, key) { return obj.then(function (x) { return x[key]; }); }); });
    return ret;
}
exports.awaitObj = awaitObj;
/**Devuelve todos los elementos de un arreglo que no estan repetidos, respetando el orden original en el que aparecen primero.
 * @param comparer Comparador que determina si 2 elementos son iguales. Se usa el operador ===
*/
function unique(arr, comparer) {
    return groupBy(arr, function (x) { return x; }, referenceEquals).map(function (x) { return x.key; });
}
exports.unique = unique;
/**Devuelve todos los elementos de todos los arreglos que no esten repetidos.
 * Conserva el orden pero no los elementos repetidos
 */
function union() {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arr[_i] = arguments[_i];
    }
    return unique(concat.apply(void 0, __spread(arr)));
}
exports.union = union;
/**
 * Devuelve todos los elementos en A que su llave no se encuentre en B las llaves de B y todos los elementos en B, en ese orden
 * esto equivale a unir los conjuntos A+B, pero dandole prioridad a los elementos en B si es que esa llave se encuentra en los dos conjuntos.
 * Esto se puede ver como una operacion de INSERT OR UPDATE en A
 * @param comparer Comparador de la llave. Es @see deepEquals por default
 */
function unionKey(a, b, getKey, comparer) {
    var effComparer = comparer || deepEquals;
    var result = [];
    //Obtiene todas las claves en B
    var bKeys = b.map(getKey);
    try {
        //Todos los elementos en A que no esten en B
        for (var a_2 = __values(a), a_2_1 = a_2.next(); !a_2_1.done; a_2_1 = a_2.next()) {
            var aItem = a_2_1.value;
            var aKey = getKey(aItem);
            if (!contains(bKeys, aKey, effComparer)) {
                result.push(aItem);
            }
        }
    }
    catch (e_13_1) { e_13 = { error: e_13_1 }; }
    finally {
        try {
            if (a_2_1 && !a_2_1.done && (_a = a_2.return)) _a.call(a_2);
        }
        finally { if (e_13) throw e_13.error; }
    }
    //Todos los elementos en B
    result.push.apply(result, __spread(b));
    return result;
    var e_13, _a;
}
exports.unionKey = unionKey;
/**Devuelve todos los elementos en A que no esten en B. Es la operacion A-B de conjuntos. Conserva el orden y los elementos repetidos de A */
function exclude(a, b, comparer) {
    var comparerEff = comparer && (function (b, a) { return comparer(a, b); });
    return a.filter(function (aItem) { return !contains(b, aItem, comparerEff); });
}
exports.exclude = exclude;
/**Devuelve todos los elementos en "items" tal que su key no se encuentre una o mas veces en "keys". Conserva el orden original de "items".
 * @param keySelector Obtiene la clave de un elemento
 * @param comparer Comparedor de igualdad. Por default se usa el shallowEquals
 */
function excludeKeys(items, keys, keySelector, comparer) {
    var comparerEff = comparer || shallowEquals;
    return exclude(items, keys, function (a, b) { return comparerEff(keySelector(a), b); });
}
exports.excludeKeys = excludeKeys;
/**Pega todos los elementos de los arreglos */
function concat() {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arr[_i] = arguments[_i];
    }
    return arr.reduce(function (acum, curr) { return __spread(acum, curr); }, []);
}
exports.concat = concat;
/**Filtra el arreglo sólo si condition == true, si es false devuelve el arreglo tal cual */
function filterIf(arr, predicate, condition) {
    return condition ? arr.filter(predicate) : arr;
}
exports.filterIf = filterIf;
/**Dado un arreglo de keys, para cada key mapea a el elemento que le corresponde.
 * Si existen varios elementos con la misma clave, cuando se encuentre esa clave se devolverá el primer elemento en el arreglo values con esa clave
 * @param keys Claves que se van a mapear
 * @param values Valores en los que se va a buscar para cada clave, el valor que tiene esa clave
 * @param keySelector Obtener la clave de un elemento
 * @param keyComparer Comparador que se usará para determinar si dos claves son iguales. Por default se usa el shallowEquals
 */
function mapKeys(keys, values, keySelector, keyComparer) {
    var effectiveKeyComparer = keyComparer || shallowEquals;
    return keys.map(function (key) { return first(values, function (value) { return shallowEquals(key, keySelector(value)); }); });
}
exports.mapKeys = mapKeys;
/**Devuelve todos los elementos en "a" que se encuentren también en "b". Conserva el orden original de "a"
 * @param comparer Comparedor de igualdad. Por default se usa el referenceEquals
 */
function intersect(a, b, comparer) {
    return intersectKeys(a, b, function (x) { return x; }, comparer || referenceEquals);
}
exports.intersect = intersect;
/**Mapea cada una de las propiedades en A que encajen en B y viceversa */
function mergeObj(a, b, merge) {
    var keys = union(Object.keys(a), Object.keys(b));
    var values = keys.map(function (key) { return ({
        key: key,
        value: merge(a[key], b[key], key)
    }); });
    return arrayToMap(values);
}
exports.mergeObj = mergeObj;
/**Devuelve true si SET contiene todos los elementos en SUBSET. Si los conjuntos son iguales devuelve true.
 * Si los dos arreglos estan vacios devuelve true
 */
function isSubset(set, subset, comparer) {
    //Si por lo menos un elemento en subset no existe en set, ya no es un subset
    return !any(subset, function (x) { return !contains(set, x); });
}
exports.isSubset = isSubset;
/**Devuelve todos los elementos en "items" tal que su key se encuentre una o mas veces en "keys". Conserva el orden original de "items".
 * @param keySelector Obtiene la clave de un elemento
 * @param comparer Comparedor de igualdad. Por default se usa el shallowEquals
 */
function intersectKeys(items, keys, keySelector, comparer) {
    return items.filter(function (item) { return contains(keys, keySelector(item), comparer || shallowEquals); });
}
exports.intersectKeys = intersectKeys;
/**Devuelve un rango de numeros */
function range(start, count, step) {
    var ret = [];
    step = step || 1;
    var end = start + count * step;
    for (var i = start; i < end; i += step) {
        ret.push(i);
    }
    return ret;
}
exports.range = range;
/**
 * Devuelve un nuevo arreglo con todo el arreglo original mas el elemento al final
 */
function push(arr, item) {
    return __spread(arr, [item]);
}
exports.push = push;
/**
 * Remplaza todos los valores del arreglo que cumplan con cierta condicion
 */
function replace(arr, condition, newValue) {
    return arr.map(function (x, i) { return condition(x, i) ? newValue : x; });
}
exports.replace = replace;
/**Elimina un elemento del arreglo */
function remove(arr, item) {
    return arr.filter(function (x) { return x != item; });
}
exports.remove = remove;
/**Elimina un elemento del arreglo dado su indice */
function removeAt(arr, index) {
    return arr.filter(function (x, i) { return i != index; });
}
exports.removeAt = removeAt;
/**
 * Combina varias funciones comparadores que pueden ser usadas para alimentar a la función sort. Se le da prioridad a los primeros comparadores,
 * si un comparador devuelve 0, entonces se evalue el segundo
 * @param comparers
 */
function combineComparers() {
    var comparers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        comparers[_i] = arguments[_i];
    }
    return function (a, b) {
        try {
            for (var comparers_1 = __values(comparers), comparers_1_1 = comparers_1.next(); !comparers_1_1.done; comparers_1_1 = comparers_1.next()) {
                var comp = comparers_1_1.value;
                var result = comp(a, b);
                if (result != 0)
                    return result;
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (comparers_1_1 && !comparers_1_1.done && (_a = comparers_1.return)) _a.call(comparers_1);
            }
            finally { if (e_14) throw e_14.error; }
        }
        return 0;
        var e_14, _a;
    };
}
exports.combineComparers = combineComparers;
/**Comparador de ordenamiento por default. Si a es mayor que b devuelve 1, si es menor -1  */
function defaultComparer(a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === null && b === undefined) {
        return 1;
    }
    else if (a === undefined && b === null) {
        return -1;
    }
    else
        return a > b ? 1 : a < b ? -1 : 0;
}
exports.defaultComparer = defaultComparer;
/**Ordena un arreglo de forma estable, a diferencia de con array.sort el arreglo original no es modificado
 * @param comparers Comparadores de ordenamiento, se le da precedencia al primero. Si no se especifica ninguno se usará el comparador por default
 */
function sort(arr) {
    var comparers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        comparers[_i - 1] = arguments[_i];
    }
    comparers = comparers.length == 0 ? [defaultComparer] : comparers;
    var toEffComparer = function (func) { return function (a, b) { return func(a.value, b.value); }; };
    //Comparamos tambien por indice
    var effComparers = __spread(comparers.map(toEffComparer), [
        function (a, b) { return a.index - b.index; }
    ]);
    var effectiveComparer = combineComparers.apply(void 0, __spread(effComparers));
    var copy = arr.map(function (x, i) { return ({ value: x, index: i }); });
    copy.sort(effectiveComparer);
    var ret = copy.map(function (x) { return x.value; });
    return ret;
}
exports.sort = sort;
/**
 * Ordena un arreglo de forma estable segun ciertas claves seleccionadas usando el comparador por default
 */
function orderBy(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comparers = keySelectors.map(function (selector) { return function (a, b) { return +defaultComparer(selector(a), selector(b)); }; });
    return sort.apply(void 0, __spread([arr], comparers));
}
exports.orderBy = orderBy;
/**Ordena un arreglo de forma estable y descendiente segun ciertas claves seleccionadas usando el comparador por default */
function orderByDesc(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comparers = keySelectors.map(function (selector) { return function (a, b) { return -defaultComparer(selector(a), selector(b)); }; });
    return sort.apply(void 0, __spread([arr], comparers));
}
exports.orderByDesc = orderByDesc;
function keysToComparer(keySelectors) {
    var comparers = (keySelectors.length == 0) ? [defaultComparer] :
        (keySelectors.map(function (selector) { return function (a, b) { return +defaultComparer(selector(a), selector(b)); }; }));
    return combineComparers.apply(void 0, __spread(comparers));
}
/**Obtiene el máximo de un arreglo dado un selector de llave */
function max(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comp = keysToComparer(keySelectors);
    return maxComparer(arr, comp);
}
exports.max = max;
/**Obtiene el mínimo de un arreglo dado un selector de llave */
function min(arr) {
    var keySelectors = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keySelectors[_i - 1] = arguments[_i];
    }
    var comp = keysToComparer(keySelectors);
    var inv = function (a, b) { return -comp(a, b); };
    return maxComparer(arr, inv);
}
exports.min = min;
/**Devuelve el valor máximo de un arreglo dado un comparador o undefined si el arreglo está vacío */
function maxComparer(arr, comparer) {
    var first = true;
    var max = undefined;
    try {
        for (var arr_9 = __values(arr), arr_9_1 = arr_9.next(); !arr_9_1.done; arr_9_1 = arr_9.next()) {
            var x = arr_9_1.value;
            if (first || (comparer(x, max) > 0)) {
                max = x;
                first = false;
            }
        }
    }
    catch (e_15_1) { e_15 = { error: e_15_1 }; }
    finally {
        try {
            if (arr_9_1 && !arr_9_1.done && (_a = arr_9.return)) _a.call(arr_9);
        }
        finally { if (e_15) throw e_15.error; }
    }
    return max;
    var e_15, _a;
}
/**Convierte un observable de T, de Promise<T> o de Observable<T> a un observable de <T>, efectivamente aplanando un observable anidado en uno desanidado */
function rxFlatten(observable) {
    var obsOfObs = observable.map(function (x) { return toObservable(x); });
    return obsOfObs.concatAll();
}
exports.rxFlatten = rxFlatten;
function toObservable(value) {
    if (value instanceof rx.Observable) {
        return value;
    }
    else {
        return rx.Observable.fromPromise(Promise.resolve(value));
    }
}
exports.toObservable = toObservable;
/**Toma los primeros N elementos del arreglo */
function take(arr, count) {
    var ret = [];
    for (var i = 0; i < Math.min(arr.length, count); i++) {
        ret.push(arr[i]);
    }
    return ret;
}
exports.take = take;
/**Obtiene le primer elemento mapeado de un arreglo o undefined */
function firstMap(arr, predicate, map) {
    for (var i = 0; i < arr.length; i++) {
        var x = arr[i];
        if (predicate(x)) {
            return map(x, i);
        }
    }
    return undefined;
}
exports.firstMap = firstMap;
/**Devuelve true si existiran duplicados en caso de editar un elemento de un arreglo
 * @param arr Arreglo
 * @param oldValueRef Valor anterior del arreglo
 * @param newValue Nuevo valor del arreglo
 */
function duplicatesOnEdit(arr, oldValue, newValue, keySelector) {
    var comparer = function (a, b) { return shallowEquals(keySelector(a), keySelector(b)); };
    var foundOldValue = false;
    try {
        for (var arr_10 = __values(arr), arr_10_1 = arr_10.next(); !arr_10_1.done; arr_10_1 = arr_10.next()) {
            var item = arr_10_1.value;
            if (comparer(item, newValue)) {
                if ((comparer(item, oldValue) && !foundOldValue)) {
                    foundOldValue = true;
                }
                else {
                    return true;
                }
            }
        }
    }
    catch (e_16_1) { e_16 = { error: e_16_1 }; }
    finally {
        try {
            if (arr_10_1 && !arr_10_1.done && (_a = arr_10.return)) _a.call(arr_10);
        }
        finally { if (e_16) throw e_16.error; }
    }
    return false;
    var e_16, _a;
}
exports.duplicatesOnEdit = duplicatesOnEdit;
/**
 * Devuelve true si existirán duplicados en caso de agregar un elemento a un arreglo que es equivalente a saber
 * si ese elemento esta contenido en el arreglo
 * @param arr
 * @param newValue
 * @param comparer  Se usa el shallow equals por default
 */
function duplicatesOnAdd(arr, newValue, keySelector) {
    var comparer = function (a, b) { return shallowEquals(keySelector(a), keySelector(b)); };
    return contains(arr, newValue, comparer);
}
exports.duplicatesOnAdd = duplicatesOnAdd;
/**Devuelve true si x tiene el metodo then, lo que indica que es una promesa */
function isPromiseLike(x) {
    return x != null && (typeof x.then) == "function";
}
exports.isPromiseLike = isPromiseLike;
/**Devuelve true si x es un observable */
function isObservable(x) {
    return x instanceof rx.Observable;
}
exports.isObservable = isObservable;
/**Devuelve true si x es un array */
function isArray(x) {
    return x instanceof Array;
}
exports.isArray = isArray;
/**Mapea el valor actual y el anterior de un observable */
function mapPreviousRx(obs, startWith) {
    var ret = obs
        .map(function (x) { return ({ prev: startWith, curr: x }); })
        .scan(function (acc, val) { return ({ prev: acc.curr, curr: val.curr }); });
    return ret;
}
exports.mapPreviousRx = mapPreviousRx;
/**Mapea cada elemento de un arreglo tomando en cuenta el elemento anterior */
function mapPrevious(items, map, initial) {
    var prev = initial;
    var ret = [];
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var it_2 = items_1_1.value;
            ret.push(map(prev, it_2));
            prev = it_2;
        }
    }
    catch (e_17_1) { e_17 = { error: e_17_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_17) throw e_17.error; }
    }
    return ret;
    var e_17, _a;
}
exports.mapPrevious = mapPrevious;
/**Calcula un agregado corrido para cada elemento de un arreglo */
function runningTotal(items, seed, reduceState, map) {
    var ret = [];
    var state = seed;
    try {
        for (var items_2 = __values(items), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
            var it_3 = items_2_1.value;
            var proj = reduceState(state, it_3);
            state = proj;
            var output = map(state, it_3);
            ret.push(output);
        }
    }
    catch (e_18_1) { e_18 = { error: e_18_1 }; }
    finally {
        try {
            if (items_2_1 && !items_2_1.done && (_a = items_2.return)) _a.call(items_2);
        }
        finally { if (e_18) throw e_18.error; }
    }
    return ret;
    var e_18, _a;
}
exports.runningTotal = runningTotal;
/**Mapea y aplana una colección. Es equivalente a  flatten(items.map(map)) */
function mapMany(items, map) {
    var result = [];
    try {
        for (var items_3 = __values(items), items_3_1 = items_3.next(); !items_3_1.done; items_3_1 = items_3.next()) {
            var x = items_3_1.value;
            var mapResult = map(x);
            result.push.apply(result, __spread(mapResult));
        }
    }
    catch (e_19_1) { e_19 = { error: e_19_1 }; }
    finally {
        try {
            if (items_3_1 && !items_3_1.done && (_a = items_3.return)) _a.call(items_3);
        }
        finally { if (e_19) throw e_19.error; }
    }
    return result;
    var e_19, _a;
}
exports.mapMany = mapMany;
/**Convierte un objeto de arreglos a un arreglo de objetos, si el objeto de arreglos esta vacio, devuelve un arreglo vacio*/
function zip(data) {
    //Checa que todo los arreglos tengan la misma longitud
    var lengths = enumObject(data).map(function (x) { return x.value.length; });
    if (!allEqual(lengths)) {
        throw new Error("Todos los arreglos deben de tener la misma longitud");
    }
    if (lengths.length == 0)
        return [];
    var count = lengths[0];
    var ret = [];
    var _loop_2 = function (i) {
        var fila = mapObject(data, function (value, key) { return value[i]; });
        ret.push(fila);
    };
    for (var i = 0; i < count; i++) {
        _loop_2(i);
    }
    return ret;
}
exports.zip = zip;
/**A una cadena que representa un numero entero, aplica el separador de miles */
function aplicarSepMiles(intpart, sep) {
    if (sep === void 0) { sep = ","; }
    if (intpart.length < 4)
        return intpart;
    var start = intpart.length % 3;
    var ret = intpart.substr(0, start);
    for (var i = start; i < intpart.length; i += 3) {
        var subpart = intpart.substr(i, 3);
        ret += i == 0 ? subpart : (sep + subpart);
    }
    return ret;
}
/**
 * Formatea un número
 * @param number El numero
 * @param integer Cantidad de zeros a la izquierda en la parte entera
 * @param decimals Cantidad de zeros a la derecha en la parte desimal
 * @param thousep Usar separador de miles. Por default es false
 * @param prefix Prefijo del numero, ejemplo $ o %. Por default es ""
 */
function formatNumber(number, integer, decimals, thousep, prefix) {
    if (integer === void 0) { integer = 0; }
    if (decimals === void 0) { decimals = 0; }
    if (thousep === void 0) { thousep = false; }
    if (prefix === void 0) { prefix = ""; }
    if (number == null)
        return "";
    number = Number(number);
    var zeroes = "00000000000000000000";
    var sign = number < 0 ? "-" : "";
    var x = Math.abs(number);
    var int = Math.trunc(x);
    var frac = x - int;
    var intText = "" + int;
    var intZeroStr = zeroes + intText;
    var intPartSinSep = intZeroStr.substr(intZeroStr.length - Math.max(integer, intText.length));
    var intPart = thousep ? aplicarSepMiles(intPartSinSep) : intPartSinSep;
    if (decimals == 0)
        return sign + prefix + intPart;
    var fracText = "" + Math.trunc(Math.round(frac * 1000 * Math.pow(10, decimals)) / 1000);
    var leftFracZeroes = zeroes.substr(0, decimals - fracText.length);
    var fracZeroStr = leftFracZeroes + fracText + zeroes;
    var fracPart = fracZeroStr.substring(0, decimals);
    return sign + prefix + intPart + "." + fracPart;
}
exports.formatNumber = formatNumber;
function nullOrEmpty(x) {
    return x == null || x == "";
}
exports.nullOrEmpty = nullOrEmpty;
var monthNames = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
/**Formatea una fecha
 * @param fullDateTime true o false para indicar si mostrar las horas o no. Por default es undefined e implicar que se mostraran las horas si el valor tiene componente de horas, si no, se mostrará sólo la fecha
 */
function formatDate(x, fullDateTime) {
    if (x == null)
        return "";
    x = new Date(x);
    var year = formatNumber(x.getFullYear(), 4);
    var month = monthNames[x.getMonth()];
    var day = formatNumber(x.getDate(), 2);
    var hours = formatNumber(x.getHours(), 2);
    var minutes = formatNumber(x.getMinutes(), 2);
    //True si se debe de mostrar hora y fecha, si no, solo la fecha
    var effFull = fullDateTime == null ? (hours != "00" || minutes != "00") : fullDateTime;
    var dateStr = day + "/" + month + "/" + year;
    if (effFull) {
        var hourStr = hours + ":" + minutes;
        return dateStr + " " + hourStr;
    }
    else {
        return dateStr;
    }
}
exports.formatDate = formatDate;
/**Convierte una fecha al formato ISO 8601 respetando la zona horaria */
function toIsoDate(x) {
    var year = formatNumber(x.getFullYear(), 4);
    var month = formatNumber(x.getMonth() + 1, 2);
    var day = formatNumber(x.getDate(), 2);
    var hours = formatNumber(x.getHours(), 2);
    var minutes = formatNumber(x.getMinutes(), 2);
    var seconds = formatNumber(x.getSeconds(), 2);
    var offsetMinVal = -x.getTimezoneOffset();
    var offsetHours = formatNumber(Math.abs(offsetMinVal / 60), 2);
    var offsetMin = formatNumber(Math.abs(offsetMinVal) % 60, 2);
    var offsetSign = offsetMinVal < 0 ? "-" : "+";
    var offset = offsetSign + offsetHours + ":" + offsetMin;
    return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + offset;
}
exports.toIsoDate = toIsoDate;
/**Formatea una fecha de tal manera que sea compatible con el excel */
function formatDateExcel(x) {
    var f = function (x) { return formatNumber(x, 2); };
    var f4 = function (x) { return formatNumber(x, 4); };
    return f4(x.getFullYear()) + "-" + f(x.getMonth() + 1) + "-" + f(x.getDate()) + " " + f(x.getHours()) + ":" + f(x.getMinutes()) + ":" + f(x.getSeconds());
}
exports.formatDateExcel = formatDateExcel;
/**Devuelve una copia de una función. Respeta las propiedades agregadas a la función */
function cloneFunction(func) {
    var ret = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return func.apply(void 0, __spread(args));
    };
    var keys = Object.keys(func);
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            ret[key] = func[key];
        }
    }
    catch (e_20_1) { e_20 = { error: e_20_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_20) throw e_20.error; }
    }
    return ret;
    var e_20, _a;
}
exports.cloneFunction = cloneFunction;
var bindOrigFuncKey = "_keautils_bindFunction_origFunctions";
/**Aplica un Function.bind respetando las propiedades agregadas a la función. Tambien se almacena la funcion original de tal manera que se puede devolver al estado original */
function bindFunction(func, thisArg) {
    var argArray = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        argArray[_i - 2] = arguments[_i];
    }
    var keys = Object.keys(func);
    var ret = func.bind.apply(func, __spread([thisArg], argArray));
    try {
        for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
            var key = keys_2_1.value;
            ret[key] = func[key];
        }
    }
    catch (e_21_1) { e_21 = { error: e_21_1 }; }
    finally {
        try {
            if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
        }
        finally { if (e_21) throw e_21.error; }
    }
    ;
    ret[bindOrigFuncKey] = ret[bindOrigFuncKey] || [];
    ret[bindOrigFuncKey] = __spread(ret[bindOrigFuncKey], [func]);
    return ret;
    var e_21, _a;
}
exports.bindFunction = bindFunction;
/**Deshace un bind aplicado con bindFunction. Un bind aplicado con Function.bind directamente no se puede deshacer. Si al argumento no se le fue aplicado un bind devuelve undefined */
function unbindFunction(func) {
    if (!func[bindOrigFuncKey]) {
        return undefined;
    }
    var arr = func[bindOrigFuncKey];
    return arr[arr.length - 1];
}
exports.unbindFunction = unbindFunction;
function syncResolve(x) {
    return {
        then: function (onfulfilled) {
            if (onfulfilled) {
                var ret = onfulfilled(x);
                if (isPromiseLike(ret))
                    return ret;
                else
                    return syncResolve(ret);
            }
            return syncResolve(x);
        }
    };
}
exports.syncResolve = syncResolve;
/**Devuelve una promesa que se resuelve en cierto tiempo. Note que si ms == 0 la promesa devuelta no se resuelve síncronamente, ya que un setTimeout(..., 0) no es síncrono*/
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
exports.delay = delay;
/**Una funcion que siempre lanza una excepción al ser llamada. Sirve para implementar cases exhaustivos, tal como esta descrito en https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript*/
function assertUnreachable(x) {
    throw new Error("Se llamó a la función assertUnreachable, esto puede indicar un tipo inesperado en una discriminación de tips");
}
exports.assertUnreachable = assertUnreachable;
/**Realiza una busqueda binaria en un arreglo, devuelve el indice del elemento mas cercano y si fue encontrado o no el elemento.
 * En caso de que no encaje devuelve el indice del ultimo elemento que es menor que el valor de busqueda. Si ningun elemento del arreglo es menor al valor de busqueda devuelve -1.
 */
function binarySearch(arr, keySelector, value, comparer) {
    var effComparer = comparer || defaultComparer;
    var minIndex = 0;
    var maxIndex = arr.length - 1;
    var currentIndex = 0;
    var currentElement;
    while (minIndex <= maxIndex) {
        currentIndex = (minIndex + maxIndex) / 2 | 0;
        currentElement = keySelector(arr[currentIndex]);
        var comp = effComparer(currentElement, value);
        if (comp < 0) {
            minIndex = currentIndex + 1;
        }
        else if (comp > 0) {
            maxIndex = currentIndex - 1;
        }
        else {
            return { index: currentIndex, match: true };
        }
    }
    return { index: minIndex - 1, match: false };
}
exports.binarySearch = binarySearch;
/**
 * Para todos los pares de elemento en left y right que cumplen con el where, devuelve ese par de elementos
 * Se respeta el orden del arreglo @see left
 * Este algoritmo corre con complejidad O^2 o NM donde N es la cantidad de elementos en left y M la cantidad de elementos en right
 * @param left Arreglo izquierdo
 * @param right Arreglo derecho
 * @param where Condicion para filtrar el producto cartesiano
 */
function innerJoin(left, right, where) {
    var ret = [];
    try {
        for (var left_1 = __values(left), left_1_1 = left_1.next(); !left_1_1.done; left_1_1 = left_1.next()) {
            var l = left_1_1.value;
            try {
                for (var right_1 = __values(right), right_1_1 = right_1.next(); !right_1_1.done; right_1_1 = right_1.next()) {
                    var r = right_1_1.value;
                    if (where(l, r)) {
                        ret.push({ left: l, right: r });
                    }
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (right_1_1 && !right_1_1.done && (_a = right_1.return)) _a.call(right_1);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
    }
    catch (e_23_1) { e_23 = { error: e_23_1 }; }
    finally {
        try {
            if (left_1_1 && !left_1_1.done && (_b = left_1.return)) _b.call(left_1);
        }
        finally { if (e_23) throw e_23.error; }
    }
    return ret;
    var e_23, _b, e_22, _a;
}
exports.innerJoin = innerJoin;
/**
 * Para todos los elementos en left y right que cumplen con el where, devuelve ese par de elementos. Si para
 * cierto elemento en left ningun par de elementos (left, right) cumple con la condicion, devuelve un par solo con el valor (left) asignado y el
 * (right) en undefined. Esto hace que todos los elementos en left sean incluidos en el resultado final incondicionalmente por lo menos una vez * Este algoritmo corre con complejidad O^2 o NM donde N es la cantidad de elementos en left y M la cantidad de elementos en right
 * @param left Arreglo izquierdo
 * @param right Arreglo derecho
 * @param where Condicion para filtrar el producto cartesiano
 */
function leftJoin(left, right, where) {
    var ret = [];
    try {
        for (var left_2 = __values(left), left_2_1 = left_2.next(); !left_2_1.done; left_2_1 = left_2.next()) {
            var l = left_2_1.value;
            var anyRight = false;
            try {
                for (var right_2 = __values(right), right_2_1 = right_2.next(); !right_2_1.done; right_2_1 = right_2.next()) {
                    var r = right_2_1.value;
                    if (where(l, r)) {
                        anyRight = true;
                        ret.push({ left: l, right: r });
                    }
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (right_2_1 && !right_2_1.done && (_a = right_2.return)) _a.call(right_2);
                }
                finally { if (e_24) throw e_24.error; }
            }
            if (!anyRight) {
                ret.push({ left: l });
            }
        }
    }
    catch (e_25_1) { e_25 = { error: e_25_1 }; }
    finally {
        try {
            if (left_2_1 && !left_2_1.done && (_b = left_2.return)) _b.call(left_2);
        }
        finally { if (e_25) throw e_25.error; }
    }
    return ret;
    var e_25, _b, e_24, _a;
}
exports.leftJoin = leftJoin;
/**Combina dos rutas. Combina correctamente las rutas con ./ y ../
 * @param ruta base
 * @param path Ruta actual
 * @param pathChar Caracter que divide a la ruta
 * @param prefix True para iniciar la ruta con el caracter de ruta, false para no iniciar, indefinido para dejarlo tal cual. Por default is true
 * @param postfix True para terminar la ruta con el caracter de ruta, false para quitarlo, indefinido para dejarlo tal cual
 */
function combinePath(basePath, path, pathChar, prefix, postfix) {
    if (pathChar === void 0) { pathChar = "/"; }
    if (prefix === void 0) { prefix = true; }
    if (postfix === void 0) { postfix = false; }
    function trim(s) {
        var start = s.startsWith(pathChar) ? 1 : 0;
        var end = s.endsWith(pathChar) ? (s.length - 1) : s.length;
        return s.substr(start, end - start);
    }
    var basePathTrim = trim(basePath);
    var pathTrim = trim(path);
    var basePathParts = basePathTrim.split(pathChar);
    var pathParts = pathTrim.split(pathChar);
    var relative = pathParts.length > 0 && pathParts[0].startsWith(".");
    var current = relative ? basePathTrim : pathTrim;
    var firstTextPart = false;
    if (relative) {
        try {
            for (var pathParts_1 = __values(pathParts), pathParts_1_1 = pathParts_1.next(); !pathParts_1_1.done; pathParts_1_1 = pathParts_1.next()) {
                var part = pathParts_1_1.value;
                if (part == "." || part == "..") {
                    if (firstTextPart)
                        throw new Error("La ruta no puede contener partes con . o .. despues de una parte de texto");
                }
                if (part == ".") {
                    //No hay que hacer nada
                }
                else if (part == "..") {
                    var currentParts = current.split("/");
                    current = currentParts.slice(0, currentParts.length - 1).join(pathChar);
                }
                else {
                    firstTextPart = true;
                    current += current == "" ? part : (pathChar + part);
                }
            }
        }
        catch (e_26_1) { e_26 = { error: e_26_1 }; }
        finally {
            try {
                if (pathParts_1_1 && !pathParts_1_1.done && (_a = pathParts_1.return)) _a.call(pathParts_1);
            }
            finally { if (e_26) throw e_26.error; }
        }
    }
    var originalStartPathChar = (relative ? basePath : path).startsWith(pathChar);
    var originalEndsWithPathChar = path.endsWith(pathChar);
    //Asignar el prefijo y postfijo
    if (prefix == true || (prefix === undefined && originalStartPathChar)) {
        current = pathChar + current;
    }
    if (postfix == true || (postfix === undefined && originalEndsWithPathChar)) {
        current = current + pathChar;
    }
    return current;
    var e_26, _a;
}
exports.combinePath = combinePath;
/**Suma un arreglo de numeros. Si el arreglo esta vacío devuelve 0.
 * Los valores nulos o indefinidos son ignorados en la suma
 */
function sum(arr) {
    return arr.filter(function (x) { return x != null; }).map(function (x) { return x; }).reduce(function (a, b) { return a + b; }, 0);
}
exports.sum = sum;
/**Convierte un observable a una promesa que se resuelve en el siguiente onNext del observable, esto es diferente a la función
 * @see rx.Observable.toPromise() que se resueve hasta que el observable es completado
*/
function nextToPromise(obs) {
    return new Promise(function (resolve, reject) { return obs.subscribe(resolve, reject); });
}
exports.nextToPromise = nextToPromise;
/**Crea una nueva promesa y devuelve por separado la promesa y las funciones que resuelven y rechazan a la promesa */
function splitPromise() {
    var resolve = null;
    var reject = null;
    var promise = new Promise(function (promResolve, promReject) {
        resolve = promResolve;
        reject = promReject;
    });
    return { promise: promise, resolve: resolve, reject: reject };
}
exports.splitPromise = splitPromise;
/**Determina si un numero esta afuera del rango, y devuelve de que parte del rango esta afuera */
function outOfRange(value, range) {
    if (range.min && ((range.min.type == "in" && value < range.min.value) || (range.min.type == "ex" && value <= range.min.value)))
        return "min";
    else if (range.max && ((range.max.type == "in" && value > range.max.value) || (range.max.type == "ex" && value >= range.max.value)))
        return "max";
    return null;
}
exports.outOfRange = outOfRange;
/**Barajea un arreglo */
function shuffle(arr) {
    function shuffleInPlace(a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
    }
    var ret = __spread(arr);
    shuffleInPlace(ret);
    return ret;
}
exports.shuffle = shuffle;
/**
 * Aplica una función a cada propiedad de un objeto, conservando los keys
 * @param obj Objeto a mapear
 * @param map Función que toma el valor y el "key" y devuelve el nuevo valor
 */
function mapObject(obj, map) {
    var ret = {};
    for (var key in obj) {
        var value = obj[key];
        ret[key] = map(value, key);
    }
    return ret;
}
exports.mapObject = mapObject;
/**Ejecuta un OR sobre un conjunto de valores ya sea síncronos o asíncronos, si los primeros valores son síncronos devuelve inmediatamente ese resultado sin esperar a los otros observables */
function orRx() {
    var arg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
    }
    try {
        //Busca los valores síncronos:
        for (var arg_1 = __values(arg), arg_1_1 = arg_1.next(); !arg_1_1.done; arg_1_1 = arg_1.next()) {
            var x = arg_1_1.value;
            if (isPromiseLike(x) || isObservable(x))
                break;
            else if (x)
                return x;
        }
    }
    catch (e_27_1) { e_27 = { error: e_27_1 }; }
    finally {
        try {
            if (arg_1_1 && !arg_1_1.done && (_a = arg_1.return)) _a.call(arg_1);
        }
        finally { if (e_27) throw e_27.error; }
    }
    var unknown = {};
    var or = function (a, b) {
        if (a && a != unknown)
            return a;
        return b;
    };
    var orArr = function (arr) { return arr.reduce(function (prev, curr) { return or(prev, curr); }); };
    var allObs = arg.map(function (x) { return isObservable(x) ? x : rx.Observable.from([x]); });
    var obsUnk = allObs.map(function (x) { return x.startWith(unknown).map(function (x) { return x; }); });
    var combine = (_b = rx.Observable).combineLatest.apply(_b, __spread(obsUnk)).map(orArr);
    return combine.filter(function (x) { return x != unknown; }).map(function (x) { return x; });
    var e_27, _a, _b;
}
exports.orRx = orRx;
/**Recorre una estructura de arbol y la devuelve en forma de arreglo */
function treeTraversal(tree, getNodes) {
    if (tree.length == 0)
        return [];
    var nodes = mapMany(tree, getNodes);
    var child = treeTraversal(nodes, getNodes);
    return __spread(tree, child);
}
exports.treeTraversal = treeTraversal;
/**Convierte una función para obtener un valor y otra que notifica el cambio del valor en un observable
 * @param getValue Función que obtiene el valor actual
 * @param listen Una función que se suscribe a los cambios del valor, toma como parámetro una función que se va a llamar cada vez que el valor que cambie y devuelve
 * una función que al ser llamada se desuscribe de la escucha de los cambios del valor
 */
function getListenToRx(getValue, listen) {
    return new rx.Observable(function (subscriber) {
        var dispose = listen(function () { return subscriber.next(getValue()); });
        subscriber.next(getValue());
        return dispose;
    });
}
exports.getListenToRx = getListenToRx;
/**Convierte un store de redux en un observable, el observable emite el valor actual en la subscripción y los siguientes valores son emitidos
 * cuando el store indica que ha cambiado su valor
 */
function reduxStoreToRx(store) {
    return getListenToRx(function () { return store.getState(); }, function (x) { return store.subscribe(x); });
}
exports.reduxStoreToRx = reduxStoreToRx;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/logic.js
// module id = 520
// module chunks = 0